module.exports = __webpack_public_path__ + "res/28-img_back.f6256de1fcc9c99ff7a41ec05c3700af.png";